import * as React from 'react';
import { Layout, Row, Card } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	getCurrency,
	getWarrantyStatus,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { TwoLineList } from '../two_line_list/TwoLineList';
import { dateFormatter } from '../../utils/DataFormatterUtils';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';

const { Content } = Layout;

function AssetDetailsCard({
	asset,

	currentUser,
}) {
	const currency = getCurrency({ currentUser });
	const serviceWarranty = nullSafeGet('warranties.0', asset);
	const partWarranty = nullSafeGet('partWarranty', asset);
	const assetDetails = [
		{
			key: 'Asset ID',
			value: asset.buyerSpecificAssetId || asset.id,
		},
		...(asset.assetNumber
			? [
					{
						key: 'Asset Number',
						value: asset.assetNumber,
					},
			  ]
			: []),
		...(asset.manufacturer
			? [
					{
						key: 'Manufacturer',
						value: asset.manufacturer,
					},
			  ]
			: []),
		...(asset.modelNumber
			? [
					{
						key: 'Model Number',
						value: asset.modelNumber,
					},
			  ]
			: []),
		...(asset.upcNumber
			? [
					{
						key: 'UPC Number',
						value: asset.upcNumber,
					},
			  ]
			: []),
		...(asset.serialNumber
			? [
					{
						key: 'Serial Number',
						value: asset.serialNumber,
					},
			  ]
			: []),
		...(asset.purchaseDate
			? [
					{
						key: 'Purchase Date',
						value: dateFormatter(asset.purchaseDate, 'MMMM D, YYYY'),
					},
			  ]
			: []),
		...(asset.originalPrice
			? [
					{
						key: 'Purchase Price',
						value: currency.format(asset.originalPrice),
						accessPermissionName: PERMISSION_NAMES.SHOW_ASSET_PRICE,
					},
			  ]
			: []),
		...(asset.installDate
			? [
					{
						key: 'Install Date',
						value: dateFormatter(asset.installDate, 'MMMM D, YYYY'),
					},
			  ]
			: []),
		...(asset.lifeExpectancyInMonths
			? [
					{
						key: 'Useful Life Expectancy (Months)',
						value: asset.lifeExpectancyInMonths,
					},
			  ]
			: []),
		...(getWarrantyStatus(serviceWarranty)
			? [
					{
						key: 'Service Warranty Status',
						value:
							getWarrantyStatus(serviceWarranty) === 'Active'
								? 'Under Warranty'
								: getWarrantyStatus(serviceWarranty) === 'Expired'
								? 'Warranty Expired'
								: 'Warranty Pending',
					},
			  ]
			: []),
		...(nullSafeGet('issueDate', serviceWarranty)
			? [
					{
						key: 'Service Warranty Start Date',
						value: dateFormatter(nullSafeGet('issueDate', serviceWarranty), 'MMMM D, YYYY'),
					},
			  ]
			: []),
		...(nullSafeGet('expirationDate', serviceWarranty)
			? [
					{
						key: 'Service Warranty End Date',
						value: dateFormatter(nullSafeGet('expirationDate', serviceWarranty), 'MMMM D, YYYY'),
					},
			  ]
			: []),
		...(nullSafeGet('provider.name', serviceWarranty)
			? [
					{
						key: 'Service Warranty Provider',
						value: nullSafeGet('provider.name', serviceWarranty),
					},
			  ]
			: []),
		...(nullSafeGet('NTEAmount', serviceWarranty)
			? [
					{
						key: 'Service Warranty Not-To-Exceed Amount',
						value: `${currency.format(serviceWarranty.NTEAmount)}`,
					},
			  ]
			: []),
		...(getWarrantyStatus(partWarranty)
			? [
					{
						key: 'Part Warranty Status',
						value:
							getWarrantyStatus(partWarranty) === 'Active'
								? 'Under Warranty'
								: getWarrantyStatus(partWarranty) === 'Expired'
								? 'Warranty Expired'
								: 'Warranty Pending',
					},
			  ]
			: []),
		...(nullSafeGet('issueDate', partWarranty)
			? [
					{
						key: 'Part Warranty Start Date',
						value: dateFormatter(nullSafeGet('issueDate', partWarranty), 'MMMM D, YYYY'),
					},
			  ]
			: []),
		...(nullSafeGet('expirationDate', partWarranty)
			? [
					{
						key: 'Part Warranty End Date',
						value: dateFormatter(nullSafeGet('expirationDate', partWarranty), 'MMMM D, YYYY'),
					},
			  ]
			: []),
		...(nullSafeGet('vendor.name', partWarranty)
			? [
					{
						key: 'Part Warranty Vendor',
						value: nullSafeGet('vendor.name', partWarranty),
					},
			  ]
			: []),
	];

	const assetTypeDetails = nullSafeGetOrElse('assetTypeDetails', asset, []);
	if (assetTypeDetails.length > 0) {
		assetTypeDetails.forEach((detail) =>
			assetDetails.push({
				key: detail.key,
				value: detail.valueAsString,
			})
		);
	}

	return assetDetails.length > 0 ? (
		<div className="rowSpacing">
			<Card className="materialCard" bodyStyle={{ padding: 0 }}>
				<div className="materialCard__body">
					<TwoLineList
						listItems={assetDetails}
						lineOneRender={(record) => record.value || '--'}
						lineTwoRender={(record) => record.key}
					/>
				</div>
			</Card>
		</div>
	) : null;
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(AssetDetailsCard));
